import React from 'react';
import tuprestamoyaImg from '../../assets/img/tuprestamoya.jpg'
import './styles.scss';

const Prestamo = () => {
  return (
    <section className="prestamo text-center py-5 w-100" style={{backgroundColor:"#c0c0c0"}}>
      <img className="" src={tuprestamoyaImg} alt="Tu prestamo ya" />
    </section>
  );
};

export default Prestamo;
